import { collection, query, where, doc, setDoc, getDoc, getDocs, updateDoc, deleteDoc, getCountFromServer, serverTimestamp } from "firebase/firestore";

import db from "./db";
import { getBook } from "./books";
import { getBookByIDAsync } from "./gbooks";

const generateTradeID = (g, r) => {
  return `${g}${Math.floor(Math.random() * 10000000)}${r}`;
}

const existingOpenTrade = async (user) => {
  return (
    (await getCountFromServer(query(
      collection(db, "trades"),
      where("user", "==", user.uid),
      where("complete", "==", false)))
    ).data().count !== 0
  );
}

const createTrade = async (user, tradeID, givingBookID, receivingBookID, type, sessionID) => {
  if (!(await existingOpenTrade(user)) &&
     (await getDoc(doc(db, "books", receivingBookID))).data().available === true &&
     tradeID.indexOf(givingBookID) === 0 && tradeID.indexOf(receivingBookID) > givingBookID.length &&
     sessionID.length > 60) {

    return await setDoc(doc(db, "trades", tradeID), {
      user: user.uid,
      email: user.email,
      name: user.displayName,
      givingBook: givingBookID,
      givingBookReceived: false,
      receivingBook: receivingBookID,
      receivingBookSent: false,
      complete: false,
      type: type,
      sessionID: sessionID,
      timestamp: serverTimestamp()
    });
  } else {
    return false;
  }
}

const saveComment = (tradeID, comment) => {
  return updateDoc(doc(db, "trades", tradeID), {comment});
}

const getTrade = async (user) => {
  const trades = await getDocs(query(collection(db, "trades"), where("user", "==", user.uid), where("complete", "==", false)));

  if (trades.size === 1) {
    const trade = {"id": trades.docs[0].id, ...(trades.docs[0].data())};
    trade.receivingBook = await getBook(trade.receivingBook);
    trade.givingBook = await getBookByIDAsync(trade.givingBook);

    return trade;
  }

  return null;
}

const cancelTrade = (trade) => {
  return deleteDoc(doc(db, "trades", trade.id));
}


export { generateTradeID, existingOpenTrade, getTrade, createTrade, cancelTrade, saveComment };
